// extracted by mini-css-extract-plugin
export var h1 = "Map-module--h1--ae8me";
export var title = "Map-module--title--D93XN";
export var titleContainer = "Map-module--title-container--ed2s8";
export var titleContainerMiddle = "Map-module--title-container--middle--v5kRy";
export var titleContainerRight = "Map-module--title-container--right--0gd+l";
export var triangle = "Map-module--triangle--yC9l4";
export var wrapper = "Map-module--wrapper--2xa8H";